import type { MediaLibraryItem, MediaKind, DisplayOrientation } from '../../../components/display/data/types';

export const MEDIA_LIBRARY_FETCH_REQUEST = 'mediaLibrary/FETCH_REQUEST';
export const MEDIA_LIBRARY_FETCH_SUCCESS = 'mediaLibrary/FETCH_SUCCESS';
export const MEDIA_LIBRARY_FETCH_FAILURE = 'mediaLibrary/FETCH_FAILURE';

// ── Upload (real backend — POST /display/upload-media) ────────────────────────
export const MEDIA_LIBRARY_UPLOAD_REQUEST = 'mediaLibrary/UPLOAD_REQUEST';

// ── Delete (real backend — DELETE /display/media/{id}) ─────────────────────────
export const MEDIA_LIBRARY_DELETE_REQUEST = 'mediaLibrary/DELETE_REQUEST';

// ── Local-only ──────────────────────────────────────────────────────────────────
export const MEDIA_LIBRARY_ADD = 'mediaLibrary/ADD';
export const MEDIA_LIBRARY_DELETE = 'mediaLibrary/DELETE';

export interface MediaLibraryUploadPayload {
  /** Set when inserting a real uploaded item (server-issued mediaId) — omitted for pure mock adds. */
  id?: string;
  name: string;
  mimeType: string;
  kind: MediaKind;
  url: string;
  sizeBytes: number;
  orientation: DisplayOrientation;
}

export interface Deferred<T = void> {
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (e: Error) => void;
}

export interface MediaLibraryUploadRequestPayload {
  locationId: string;
  file: File;
  orientation: DisplayOrientation;
  deferred: Deferred<MediaLibraryUploadPayload>;
  onProgress?: (percent: number) => void;
}

export interface MediaLibraryFetchRequestPayload {
  locationId: string;
}

export interface MediaLibraryDeleteRequestPayload {
  id: string;
  locationId: string;
  deferred: Deferred;
}

export interface MediaLibraryState {
  items: MediaLibraryItem[];
  loading: boolean;
  error: string | null;
}
